export default __webpack_public_path__ + "media/images/gnu_logo-cb8a5ca0.svg";